import { SEO } from '@components/common';
import {
  Hero,
  Services,
  HowItWorks,
  WhyUs,
  LatestBlogPost,
  SecurityReadinessAssessment,
  CTA,
} from '@components/sections';

// Organization and WebSite structured data
const homeStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'The CISO Network',
      url: 'https://thecisonetwork.com',
      logo: 'https://thecisonetwork.com/logo.png',
      description: 'Fractional CISO services for growing businesses',
      sameAs: ['https://linkedin.com/company/thecisonetwork', 'https://twitter.com/thecisonetwork'],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@thecisonetwork.com',
      },
    },
    {
      '@type': 'WebSite',
      name: 'The CISO Network',
      url: 'https://thecisonetwork.com',
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeStructuredData) }}
      />
      <SEO title="Fractional CISO Cybersecurity Leadership | The CISO Network" />
      <Hero />
      <Services />
      <HowItWorks />
      <WhyUs />
      <SecurityReadinessAssessment />
      <LatestBlogPost />
      <CTA />
    </>
  );
}
